import AnalysisControlBase from './AnalysisControlBase';

export default class ComplexAnalysisControl extends AnalysisControlBase {
    _getPanelTitle() {
        return this.resourcesHandler.get('ComplexAnalysis_PanelTitle');
    }

    _getFormBody() {
        const r = this.resourcesHandler;
        return `${this._section('AnalysisSection_Design')}
                <div class="form-group col-12 mb-1">            
                    <div style="width: 100%; height: 500px; overflow: auto" class="xpq-designer-container"></div>
                </div>
                ${this._section('AnalysisSection_Output')}
                <div class="form-group col-12 mb-1 d-flex">
                    <div class="col-6 mb-3">
                        <div class="form-group">
                            <label class="form-label">${r.get('Analysis_ResultLayerName')}:</label>
                            <input class="form-control" type="text" id="${this._id('analysis-name')}">
                        </div>
                    </div>
                    <div class="col-6 mb-3">
                        <div class="form-group">
                            <label class="form-label">${r.get('Analysis_ResultPkField')}:</label>
                            <input class="form-control" id="${this._id('analysis-pk-field')}">
                        </div>
                    </div>
                </div>
                <div class="form-group col-12 mb-1 d-flex">
                    <div class="col-6 mb-3">
                        <div class="form-group">
                            <label class="form-label">${r.get('Analysis_ResultGeomField')}:</label>
                            <input class="form-control" id="${this._id('analysis-geom-field')}">
                        </div>
                    </div>
                    <div class="col-6 mb-3 align-content-center pt-4">
                        <div class="form-group" style="display: flex; flex-direction: row-reverse; height: 1.2rem; justify-content: flex-end;">
                            <label class="form-label ml-1">${r.get('Analysis_SpatialFilter')}</label>
                            <div id="${this._id('spatial-filter')}"></div>
                        </div>
                    </div>
                </div>
                `;
    }

    _wireWizardEvents() {
        const options = {
            generalResources,
            customFormResources,
            uiActionResources,
            layoutResources,
            rootUrl: rootURL
        };
        this.designer = new XpQueryDesigner(document.querySelector(".xpq-designer-container"), _xpQueryResources, options);

        this._$('analysis-pk-field').kendoComboBox(this._fieldsComboOptions());
        this._$('analysis-geom-field').kendoComboBox(this._fieldsComboOptions());

        this.designer.eventBus.on(XpqDesignerEvents.OUTPUT_VALUES_CHANGED,
            e => {
                const pkItems = [];
                const geomItems = [];
                for (const item of e.outputValues) {
                    switch (item.dataType) {
                        case 'GEOMETRY': {
                            geomItems.push({ FieldName: item.outputName, Id: item.outputName });
                            break;
                        }
                        case 'INTEGER':
                        case 'NUMERIC':
                        case 'STRING': {
                            pkItems.push({ FieldName: item.outputName, Id: item.outputName });
                            break;
                        }
                    }
                }
                this._setComboData('analysis-pk-field', pkItems);
                this._setComboData('analysis-geom-field', geomItems);
                this._refreshAutoName();
            }
        );

        this.designer.eventBus.on(XpqDesignerEvents.DATASOURCES_LOADED,
            e => {
                if (this._includeAnalyses()) {
                    const storedAnalysis = this._loadStoredAnalyses();
                    if (storedAnalysis != null && storedAnalysis.length > 0) {
                        var storedParent = null;
                        for (const item of e.data) {
                            if (item.Id == "type_XPQUERY_INSTANT") {
                                storedParent = item;
                                break;
                            }
                        }
                        if (storedParent == null) {
                            storedParent = {
                                Id: "type_XPQUERY_INSTANT",
                                Name: "DataSourceType_XPQUERY_INSTANT",
                                Items: []
                            };
                            e.data.push(storedParent);
                        }
                        storedAnalysis.forEach(a => {

                            storedParent.Items.push(
                                {
                                    "Id": "xp_query_instant_" + a.Id,
                                    "Name": a.Key,
                                    "Attr": [
                                        "0",
                                        "XPQUERY_INSTANT",
                                        a.XpQuery
                                    ]
                                }
                            );
                        });
                    }
                }
            }
        );

        const switchMessages = {
            checked: this.resourcesHandler.get('Yes'),
            unchecked: this.resourcesHandler.get('No')
        };

        this._$('spatial-filter').kendoSwitch({
            messages: switchMessages,
            checked: false
        });
    }

    _defaultLayerName() {
        return this.designer != null && this.designer.dsDesigner != null
            ? (this.designer.dsDesigner.getXpQueryName() || '')
            : '';
    }

    _validate() {
        const errors = [];
        const dataSources = this.designer != null && this.designer.dsDesigner != null
            ? this.designer.dsDesigner.getDataSources()
            : null;
        if (dataSources == null || dataSources.length === 0) {
            errors.push({
                selector: '.xpq-designer-container',
                message: this.resourcesHandler.get('Analysis_ValidationNoDataSource')
            });
        }
        const outputValues = this.designer != null && this.designer.outputValues != null
            ? this.designer.outputValues.getOutputValues()
            : null;
        if (outputValues == null || outputValues.length === 0) {
            errors.push({
                selector: '.xpq-designer-container',
                message: this.resourcesHandler.get('Analysis_ValidationNoOutput')
            });
        }
        return errors;
    }

    _buildAnalysisPayload() {
        const outputValues = this.designer.outputValues.getOutputValues()
        var geomField = this._combo('analysis-geom-field').value();
        var pkField = this._combo('analysis-pk-field').value();
        if (outputValues) {
            for (const outputValue of outputValues) {
                if (geomField != null && geomField != '' && pkField != null && pkField != '') break;

                switch (outputValue.dataType) {
                    case 'GEOMETRY': {
                        if (geomField == null || geomField == '') {
                            geomField = outputValue.outputName;
                        }
                        break;
                    }
                    case 'INTEGER':
                    case 'NUMERIC':
                    case 'STRING': {
                        if (pkField == null || pkField == '') {
                            pkField = outputValue.outputName;
                        }
                        break;
                    }
                }
            }
        }

        const data = {
            type: "Complex",
            layerName: this._$('analysis-name').val() === ''
                ? this._defaultLayerName()
                : this._$('analysis-name').val(),
            pkField: pkField,
            geomField: geomField,
            bboxStrategy: this._$('spatial-filter').data('kendoSwitch').check()
        }
        //return data;
        return new Promise((resolve, reject) => {
            try {
                let postData = {
                    type: "ComplexQuery",
                    name: this.designer.dsDesigner.getXpQueryName(),
                    dataSources: this.designer.dsDesigner.getDataSources(),
                    joins: this.designer.dsDesigner.getJoins(),
                    filter: this.designer.dsDesigner.getXpQueryFilter(),
                    outputValues: outputValues                    
                }

                let url = rootUrl + 'XpQuery/GetXpQueryEngine';

                $.ajax({
                    type: "POST",
                    url: url,
                    async: true,
                    data: JSON.stringify(postData),
                    contentType: "application/json; charset=utf-8",
                    success: (result) => {
                        if (result != null) {
                            if (result?.Error != null) {
                                reject(result.Error);
                            }
                            else {
                                for (const key of Object.keys(data)) {
                                    result[key] = data[key];
                                }
                                resolve(result);
                            }                            
                        }
                    },
                    error: (e) => {
                        reject(e)
                    }
                });
            } catch (err) {
                reject(err);
            }
        });
    }
}
